import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-stone-100 px-5 py-20 sm:py-28" data-id="element-79" data-mp="1l9o779vjm1m9">
      <div className="mx-auto max-w-2xl" data-id="element-80" data-mp="1ge0jz00mfije">
        <h2 className="text-center text-3xl font-bold leading-tight tracking-tight text-stone-900 sm:text-4xl" data-id="element-81" data-mp="2e0fxjqpxfw1o">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 space-y-3" data-id="element-82" data-mp="291wato3ieg89">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-lg border border-stone-200 bg-white" data-id="element-83" data-mp="1z3owze4ioeah" data-mpi={index}>
                <h3 data-id="element-84" data-mp="soeksck913be">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-600" data-id="element-85" data-mp="skqqvcaw6ew5">
                    <span className="text-sm font-semibold text-stone-900" data-id="element-86" data-mp="fj8hvmt4o9bj">
                      {faq.q}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-orange-600 transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-87" data-mp="kko59lis2rx3" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-88" data-mp="1s3oh2gcsd9n">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-89" data-mp="3jxyixg9bpqrw">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-stone-600" data-id="element-90" data-mp="1ppcm39eced64">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}